export const USER_REQUEST = 'USER_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_ERROR = 'USER_ERROR'
export const USER_TOGGLE_DRAWER = 'USER_TOGGLE_DRAWER'
export const USER_SET_DRAWER = 'USER_SET_DRAWER'
export const USER_START_LOADING = 'USER_START_LOADING'
export const USER_FINISH_LOADING = 'USER_FINISH_LOADING'
export const USER_ANULAR_AVISO_CUESTIONARIOS_PENDIENTES = 'USER_ANULAR_AVISO_CUESTIONARIOS_PENDIENTES'